import {
  ContactFragment,
  DealFragment,
  FinanceEnumsQuoteTypeEnum,
  LegalEntityForSelectFragment,
  QuotePricingLineItemFragment,
} from 'generated/resources/graphql'

import i18n from 'modules/core/lib/i18n'

// TODO this is copied from factorial-one but currently they're not exporting it
type Variant = 'neutral' | 'info' | 'positive' | 'warning' | 'critical'

const quoteTranslateStatus = (status: string): string => {
  switch (status) {
    case 'accepted':
      return i18n.t('finance.quotes.status.accepted')
    case 'rejected':
      return i18n.t('finance.quotes.status.rejected')
    case 'draft':
      return i18n.t('finance.quotes.status.draft')
    default:
      return ''
  }
}

const quoteStatusAsVariant = (status: string): Variant => {
  switch (status) {
    case 'accepted':
      return 'positive'
    case 'rejected':
      return 'warning'
    default:
      return 'neutral'
  }
}

const quoteTranslateType = (quoteType: FinanceEnumsQuoteTypeEnum): string => {
  switch (quoteType) {
    case 'products':
      return i18n.t('finance.quotes.quote_type.product')
    case 'timeandmaterials':
      return i18n.t('finance.quotes.quote_type.time_and_materials')
    default:
      return ''
  }
}

interface QuoteDocument {
  quoteNumber?: string | null
  currency?: string | null
  expirationDate?: string | null

  recipientName?: string | null
  recipientAddressLine1?: string | null
  recipientAddressLine2?: string | null
  recipientCity?: string | null
  recipientPostalCode?: string | null
  recipientState?: string | null
  recipientCountryCode?: string | null
  recipientTaxId?: string | null

  client?: ContactFragment | null
  legalEntity?: LegalEntityForSelectFragment | null
  issuerName?: string | null
  deal?: DealFragment | null
}

const profitPercentage = (profitCents: number, priceCents: number) => {
  if (profitCents === 0) {
    return 0
  }

  if (priceCents === 0) {
    if (profitCents > 0) {
      return 100
    }
    return -100
  }

  return Math.round((profitCents / priceCents) * 100)
}

// Same as QuotePricingLineItemFragment but changing types from 'any' to 'number'
type QuotePricingLineItem = Omit<
  QuotePricingLineItemFragment,
  'baseCostCents' | 'basePriceCents' | 'unitCostCents' | 'unitPriceCents'
> & {
  baseCostCents?: number | null
  basePriceCents?: number | null
  unitCostCents?: number | null
  unitPriceCents?: number | null
}

export {
  quoteTranslateStatus,
  quoteStatusAsVariant,
  QuoteDocument,
  quoteTranslateType,
  profitPercentage,
  QuotePricingLineItem,
}
